<template>
  <!-- CpapRequestメニュー -->
  <div id="CpapRequestMenu">
    <div id="container-center">
      <div class="title is-3">預託機処方申込み</div>
      <div class="cogrid-area">
        <div class="grid-container">
          <ul class="tile-container">
            <!-- 院内在庫注文、注文履歴検索に関しては、2024年度に持ち越しのためコメントアウト（2023.10丸山） -->
            <!-- <li>
              <div class="contents">
                <router-link :to="{name:'CpapEscrowRequest', params:{externalUser:true}}">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-cart-outline mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">預託院内在庫<br/>(器械/用品)注文</div>
                </router-link>
              </div>
            </li>
            <li>
              <div class="contents">
                <router-link :to="{name:'CpapEscrowRequestList', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-text-search mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">預託院内在庫<br/>注文履歴検索</div>
                </router-link>
              </div>
            </li> -->
            <li>
              <div class="contents">
                <router-link :to="{name:'CpapRequest', params:{instrument:true}}">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-playlist-edit mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">預託機新規<br/>処方申込み</div>
                </router-link>
              </div>
            </li>
            <li>
              <div class="contents">
                <router-link :to="{name:'CpapPatientList', params:{isEscrow:true}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-account-multiple mdi-48px" style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">預託機処方変更<br/>・再開申込み<br/><span style="font-size: 13px;">(既存患者への処方)</span></div>
                </router-link>
              </div>
            </li>
            <li>
              <div class="contents">
                <router-link to="/guest/cpap/cpapMenu">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-keyboard-return mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">CPAP処方・配送サービスに戻る</div>
                </router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
export default {
  name: "CpapMenu",
  methods: {
    isActive: function(roles){
      return (roles.indexOf(this.roleId) >= 0);
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    return {
      cpapRequestComfirm: false,
      role,
    };
  },
  components: {}
};
</script>

<style lang="scss" >
.service-list {
  width: 100%;
}
.grid-area {
  display: grid;
  width: 900px;
  margin: 0 auto;
}
.grid-container {
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-template-rows: 150px 1fr 100px;
  height: 100vh;
}

/*デザイン設定*/
.tile-container {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.tile-container > li {
  height: 150px;
  width: 150px;
  padding: 5px;
  background: linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
  );
  background: -moz-linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
  );
  background: -webkit-linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
  );
  display: table-cell;
  text-align: center;
}
.contents {
  display: table-cell;
  height: 150px;
  width: 150px;
  text-align: center;
  vertical-align: middle;
}

/*グリッド設定*/
.tile-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
}
.subtext {
  font-size: 12px;
}
.outline {
  display        : inline-block;
  color          : red;            /* 文字の色 */
  letter-spacing : 1px;                /* 文字間 */
  font-weight    : bold; 
  text-shadow    : 
       1px  1px 0px white,
      -1px  1px 0px white,
       1px -1px 0px white,
      -1px -1px 0px white,
       1px  0px 0px white,
       0px  1px 0px white,
      -1px  0px 0px white,
       0px -1px 0px white;        /* 文字の影 */
}
.cogrid-area {
  display: grid;
  width: 700px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapRequestMenu.vue